module.exports = __webpack_public_path__ + "static/media/profile-tony.919571a5.jpg";